
import { Vue, Component, Prop } from "vue-property-decorator";
import IconLogo from "./IconLogo.vue";

@Component({
  components: { IconLogo },
})
export default class FullscreenLoader extends Vue {
  @Prop({ default: "Loading" }) text: string;
}
